<template lang="pug">
    router-link.controller-detect( to="/vibe" ) 
        v-card.controller-detect__card( :disabled="!gamepadConnection" outlined )
            v-list-item( two-line )
                v-list-item-avatar( tile width="90" height="50" color="white" )
                    v-img( :src="gamepadAsset" contain )
                v-list-item-content
                    div( v-if="gamepad" )
                        v-list-item-title
                            span.controller-detect__type {{ gamepadType }} 
                            | Gamepad
                        v-list-item-subtitle( v-if="gamepadVibration" ) Rumble enabled controller
                        v-list-item-subtitle( v-else ) Rumble NOT supported
                    div( v-else )
                        v-list-item-title No Controller Detected
                        v-list-item-subtitle Press a button to connect
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    
    export default {
        name: "ControllerDetect",
        computed: {
            ...mapGetters([
                'gamepad',
                'gamepadType',
                'gamepadConnection',
                'gamepadVibration'
            ]),
            gamepadAsset() {
                let type = this.gamepadType || 'none';
                return require('@/assets/controller-'+type+'.png');
            }
        },
        mounted() {
            this.gamepadListeners();
            this.gamepadUpdate();
        },
        methods: {
            ...mapActions([
                'setGamepad',
                'setGamepadConnection'
            ]),
            gamepadListeners() {
                window.addEventListener("gamepadconnected", (e) => {
                    this.setGamepad( e.gamepad );
                });
                window.addEventListener("gamepaddisconnected", () => {
                    this.setGamepadConnection( false );
                });
            },
            gamepadUpdate() {
                if ( this.gamepad ) this.setGamepad( navigator.getGamepads()[ this.gamepad.index ] );
                requestAnimationFrame( this.gamepadUpdate.bind(this) );
            }
        }
    }
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/main';

$module: 'controller-detect';

.#{$module} {
    text-decoration: none;

    &__card {
        position: relative;
    }

    &--disconnected {
        &:before {
            content: '';
            position: absolute;
            display: block;
            width: 100%;
            height: 100%;
            background-color: rgba(#ffffff, 0.7);
        }
    }

    &__headline {
        @extend .overline;
    }

    &__type {
        text-transform: uppercase;
    }
}
</style>